import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "card-container"
};
const _hoisted_2 = {
  class: "code_box"
};
const _hoisted_3 = {
  class: "dialog-footer"
};
import { reactive, ref, toRefs } from "vue";
import QRCode from "qrcodejs2";
import { useStore } from "@/store/index";
export default {
  __name: 'index',
  props: {
    loginForm: {
      type: Object,
      default: () => {}
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const store = useStore();
    const props = __props;
    const {
      loginForm
    } = toRefs(props);
    const loginFormData = ref({
      captcha: "",
      username: "",
      password: "",
      secretKey: ""
    });
    const lightDialogStyle = {
      "--el-bg-color": "#fff",
      "--el-text-color-primary": "#303133",
      "--el-dialog-bg-color": "#fff",
      // 主按钮（primary）
      "--el-button-primary-bg-color": "#409eff",
      "--el-button-primary-text-color": "#fff",
      "--el-button-primary-border-color": "#409eff"
    };
    const dialogVisible = ref(false);
    const loginRules = reactive({
      captcha: [{
        required: true,
        trigger: "blur",
        message: "Please fill in the verification code"
      }]
    });
    const loading = ref(false);
    const qCodeUrl = ref("");
    const qrCodeRef = ref(null);
    const isQrcode = ref(true);
    const captchaRef = ref(null);
    const loginFormDataRef = ref(null);
    const confirmInput = () => {
      const {
        username,
        password
      } = loginForm.value;
      loginFormData.value.username = username;
      loginFormData.value.password = password;
      loginFormData.value.secretKey = store.secretKey;
      loginFormDataRef.value.validate(async valid => {
        if (!valid) return;
        loading.value = true;
        try {
          await store.loginSitekey(loginFormData.value);
          close();
        } finally {
          loading.value = false;
        }
      });
    };
    const handleBlur = event => {
      const input = event.target;
      if (input.value.startsWith("0")) {
        input.value = " " + input.value;
      }
    };
    const initCode = () => {
      qCodeUrl.value = store.urlKey;
      if (!store.urlKey) {
        isQrcode.value = false;
        return;
      }
      // 清空已有二维码，防止重复渲染
      if (qrCodeRef.value) {
        qrCodeRef.value.innerHTML = "";
      }
      new QRCode(qrCodeRef.value, {
        text: qCodeUrl.value,
        // 需要生成二维码的内容
        width: 300,
        height: 300,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.M
      });
    };
    const handleShow = () => {
      initCode();
      captchaRef.value.focus();
    };
    const open = () => {
      dialogVisible.value = true;
    };
    const close = () => {
      loginFormData.value = {
        captcha: "",
        username: "",
        password: "",
        secretKey: ""
      };
      qCodeUrl.value = "";
      loginFormDataRef.value.resetFields();
      dialogVisible.value = false;
    };
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        title: `Please enter Google Authenticator ${qCodeUrl.value.value !== '' ? 'binding' : ''} verification`,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogVisible.value = $event),
        "modal-append-to-body": true,
        width: "400px",
        center: "",
        onOpened: handleShow,
        style: lightDialogStyle
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: close
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("cancel")])),
          _: 1,
          __: [3]
        }), _createVNode(_component_el_button, {
          loading: loading.value,
          type: "primary",
          onClick: confirmInput
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode(" confirm ")])),
          _: 1,
          __: [4]
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [isQrcode.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "qrcode",
          ref_key: "qrCodeRef",
          ref: qrCodeRef
        }, null, 512)) : _createCommentVNode("", true)]), _createVNode(_component_el_form, {
          ref_key: "loginFormDataRef",
          ref: loginFormDataRef,
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
          model: loginFormData.value,
          rules: loginRules,
          class: "login-form",
          "auto-complete": "on",
          "label-position": "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "captcha"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, null, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                ref_key: "captchaRef",
                ref: captchaRef,
                modelValue: loginFormData.value.captcha,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => loginFormData.value.captcha = $event),
                style: {
                  "width": "100%"
                },
                placeholder: "Captcha",
                maxlength: "6",
                name: "captcha",
                tabindex: "3",
                controls: false,
                onBlur: handleBlur,
                onKeyup: _withKeys(confirmInput, ["enter"])
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["title", "modelValue"])]);
    };
  }
};